import idataCodingStyles from '../common/global-styles/idatacoding.module.less'
import projectStyles from './project.module.less'
import React, { useEffect, useRef, useState } from 'react'
import {
  Table,
  message,
  Col,
  Row,
  Tabs,
  Button,
  Input,
  Popconfirm,
  Modal,
  ConfigProvider,
  Pagination,
  InputNumber,
  Tooltip,
  Progress,
} from 'antd'
import {
  FieldNumberOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  TeamOutlined,
  CalendarOutlined,
  KeyOutlined,
  DownloadOutlined,
  FileTextOutlined,
  TableOutlined,
  BarsOutlined,
} from '@ant-design/icons'

import zhCN from 'antd/lib/locale/zh_CN'
import ProfileOutlined from '@ant-design/icons/lib/icons/ProfileOutlined'
import LockOutlined from '@ant-design/icons/lib/icons/LockOutlined'
import studentempty from '../../static/image/studentempty@2x.png'


import { BACKEND_API_URL, BACKEND_URL } from '../../constants/constants'

import SplitPane from 'react-split-pane'
import './project-split-pane.css'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'
import Draggable from 'react-draggable'
import lodingGif from '../../static/image/task/loding.gif'
import PublicTipModal from '../components/PublicTipModal/PublicTipModal'
import AddStudentModal from './components/AddStudentModal/AddStudentModal'


const { TabPane } = Tabs
const TSplitPane: any = SplitPane

/** 教师教室管理页面 */
export interface Props {
  classroom_id: string | number
  college_id: any
  course_id: any
  course_name: any
}
const ProjectClassroomManager: React.FC<Props> = (props) => {
  const { classroom_id, college_id, course_id, course_name } = props

  const reportExportTimer = useRef<any>()

  const [classRoomInfo, setClassRoomInfo] = useState(null as any) //班级信息
  const [classStudentList, setClassStudentList] = useState(null as any) //班级学生列表

  const [studentTaskStatusList, setStudentTaskStatusList] = useState(null as any) //班级学生列表

  const [studentLoaded, setStudentLoaded] = useState(false) // 学生列表加载中
  const [classStudentTotalCount, setClassStudentTotalCount] = useState(
    null as any
  ) //班级学生总数
  const [classStudentResultSum, setClassStudentResultSum] = useState(
    null as any
  ) //满足查询条件的学生数量

  const [classStatusStudentResultSum, setClassStatusStudentResultSum] = useState(
    null as any
  ) //班级学生总数

  
  const [editClassRoomName, setEditClassRoomName] = useState(null as any) //编辑的班级名称
  const [editClassRoomNumber, setEditClassRoomNumber] = useState(null as any) //编辑的班级名称
  const [editClassRoomPasswd, setEditClassRoomPasswd] = useState(null as any) //编辑的班级名称

  const [sudentCode, setStudentCode] = useState(null as any) //学生任务代码
  const [studentAnswer, setStudentAnswer] = useState(null as any) //学生任务答案

  const [currentTask, setCurrentTask] = useState(null as any) //教师点击的当前任务

  const [studentName, setStudentName] = useState(null as any) //当前学生的姓名
  const [studentAvatar, setStudentAvatar] = useState(
    'static/avatar/default_avatar.png'
  ) //当前学生的头像

  const [showClassPasswd, setShowClassPasswd] = useState(false) //

  const defaultUserAvatar = 'static/avatar/default_avatar.png'

  const [reportScore, setReportScore] = useState(null as any)
  const [scoreAction, setScoreAction] = useState(false)
  const [batchScore, setBatchScore] = useState(null as any)

  const [activeTabkKey, setActiveTabkKey] = useState('1')
  const page = useRef(1) //当前学生页
  const pageSize = useRef(10) //每页学生数量
  const queryStudentContent = useRef('') //查询字符串

  const [isEditModalVisible, setIsEditModalVisible] = useState(false)
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false)
  const [scoreActionVisible, setScoreActionVisible] = useState(false)

  const [selectedRowKeys, setSelectedRowKeys] = React.useState([] as any[])
  const currentStudentId = useRef(0)

  const [exportBeforeModalVis, setExportBeforeModalVis] = useState(false)
  const [exportModalLoading, setExportModalLoading] = useState(false)

  const [addStudentModalVis, setAddStudentModalVis] = useState(false)

  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)
  const [selectedStudentId, setSelectedStudentId] = useState(0) // 选中的学生id

  const [reportExportModalVisible, setReportExportModalVisible] = useState(
    false
  ) // 报告导出Modal
  const [downloadBeforeModalVis, setDownloadBeforeModalVis] = useState(false)
  const [downloadBeforeInfo, setDownloadBeforeInfo] = useState<any>()
  // const [reportExportMessage, setReportExportMessage] = useState(''); // 报告导出的消息提示
  const [reportExportInfo, setReportExportInfo] = useState(null as any)
  const [downloadUrl, setDownloadUrl] = useState('') // 报告下载url
  const [resetPasswordModalVis, setResetPasswordModalVis] = useState(false)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const editorReadOnlyoptions = {
    readOnly: true,
    selectOnLineNumbers: true,
    fontSize: 14,
    minimap: { enabled: false },
    lineDecorationsWidth: 5,
    lineNumbersMinChars: 2,
    quickSuggestions: false,
    automaticLayout: true, // 拖拽分屏线时自适应宽度
  }

  useEffect(() => {
    queryClassRoom()
    queryStudentTaskStatus()
    getReportExportStatus()
  }, [])

  const intervalGetReportExportStatus = () => {
    reportExportTimer.current = setInterval(() => {
      let data = {
        classroom_id: classroom_id,
        project_id: course_id,
      }
      sendHttpPostRequest(
        'report/api/batch_classroom_report_status',
        data,
        (res) => {
          if (!res.data.status) {
            setExportModalLoading(true)
          } else {
            setExportModalLoading(false)
            clearInterval(reportExportTimer.current)
          }
        }
      )
    }, 2000)
  }

  const getReportExportStatus = () => {
    let data = {
      classroom_id: classroom_id,
      project_id: course_id,
    }
    sendHttpPostRequest(
      'report/api/batch_classroom_report_status',
      data,
      (res) => {
        if (!res.data.status) {
          setExportModalLoading(true)
          intervalGetReportExportStatus()
        } else {
          setExportModalLoading(false)
          clearInterval(reportExportTimer.current)
        }
      }
    )
  }

  /** 查询班级信息 */
  const queryClassRoom = () => {
    setStudentLoaded(false)
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_student_list',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        college_id: college_id,
        course_id: course_id,
        query: queryStudentContent.current,
        page: page.current,
        pagesize: pageSize.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setStudentLoaded(true)
          setClassRoomInfo(response.query_info)
          let stuList = response.query_info.student_list
          setClassStudentList([
            ...stuList?.map((item) => ({ ...item, download_status: 0 })),
          ])
          setEditClassRoomName(response.query_info.name)
          setEditClassRoomNumber(response.query_info.number)
          setEditClassRoomPasswd(response.query_info.password)
          setClassStudentTotalCount(response.student_total_count)
          setClassStudentResultSum(response.student_result_sum)
        } /*else if (response.code == -501) {
                权限不足
                window.location.href = '/oam_login?next=oam_menu';
            } */ else {
          message.error(response.message)
        }
      }
    )
  }

  /** 查询班级学生任务状态信息 */
  const queryStudentTaskStatus = () => {
    setStudentLoaded(false)
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_student_learning_progress',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        college_id: college_id,
        course_id: course_id,
        query: queryStudentContent.current,
        page: page.current,
        pagesize: pageSize.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setStudentLoaded(true)
          setStudentTaskStatusList(response?.query_info?.student_list)
          setClassStatusStudentResultSum(response.student_result_sum)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /** 编辑更新班级信息 */
  const updateClassRoom = (
    classroom_id,
    class_password,
    class_name,
    class_number
  ) => {
    if (class_password.trim() == '') {
      message.error('班级密码不能为空！')
      return ''
    }
    if (class_name.trim() == '') {
      message.error('班级名称不能为空！')
      return ''
    }

    sendHttpPostRequest(
      'classroom/api/user_update_classroom/',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        password: class_password,
        name: class_name,
        number: class_number,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          //message.success("教室创建成功~");
          queryClassRoom()
          setIsEditModalVisible(false)
        } /*else if (response.code == -501) {
                    权限不足
                    window.location.href = '/oam_login?next=oam_menu';
                } */ else {
          message.error(response.message)
        }
      }
    )
  }

  /** 查询班级信息 */
  const queryClassRoomStudentSubmission = (user_id, exercise_id) => {
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_student_submission/',
      {
        sessionid: Cookies.get('sessionid'),
        exercise_id: exercise_id,
        user_id: user_id,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setStudentCode(response.code)
          setStudentAnswer(response.answer)
          setIsDetailModalVisible(true)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /** 查询班级信息 */
  const deleteClassRoomStudent = (user_id: any) => {
    sendHttpPostRequest(
      'classroom/api/user_remove_classroom_student/',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        user_id: user_id,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          message.success('移出成功~')
          queryClassRoom()
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const handleEditOk = () => {
    setIsEditModalVisible(false)
    setIsDetailModalVisible(false)
  }

  const handleEditCancel = () => {
    setIsEditModalVisible(false)
    setIsDetailModalVisible(false)
  }

  const editClass = () => {
    setIsEditModalVisible(true)
  }

  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryClassRoom()
  }

    //页码和页数发生了变化
    const onStatusPageChange = (newPage: number, newPageSize?: number | undefined) => {
      page.current = newPage ? newPage : 1
      if (newPageSize) {
        pageSize.current = newPageSize
      }
      queryStudentTaskStatus()
    }

  /** 任务状态和颜色的映射 */
  const getColorByStatus = (status: number) => {
    if (status == 0) {
      return '#f2f2f2'
    } else if (status == 1) {
      return '#9a3232'
    } else {
      return '#4f46e5'
    }
  }

  /** 答题状态和题号颜色的映射 */
  const getFontColorByStatus = (status: number) => {
    if (status == 0) {
      return '#4f46e5'
    } else {
      return '#fff'
    }
  }

  const exportScore = () => {
    sendHttpPostRequest(
      'classroom/api/user_export_classroom_score/',
      {
        sessionid: Cookies.get('sessionid'),
        college_id: college_id,
        course_id: course_id,
        classroom_id: classroom_id,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          window.open(BACKEND_URL + response.url)
          message.success('导出成功')
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const beforeDownloadReport = () => {
    let data = {
      classroom_id: classroom_id,
      project_id: course_id,
    }
    sendHttpPostRequest('report/api/get_classroom_report_info', data, (res) => {
      if (res.code == 0) {
        if (res.data.report_count == 0) {
          exportAllClassroomReports()
        } else {
          setDownloadBeforeInfo(res.data)
          setDownloadBeforeModalVis(true)
        }
      } else {
        message.error(res.msg)
      }
    })
  }

  // 下载报告
  const downloadClassroomReport = () => {
    window.location.href =
      BACKEND_API_URL +
      'report/api/download_classroom_report/?project_id=' +
      course_id +
      '&classroom_id=' +
      classroom_id +
      '&sessionid=' +
      Cookies.get('sessionid')
  }

  const exportAllClassroomReports = () => {
    let _params = {
      sessionid: Cookies.get('sessionid'),
      classroom_id: classroom_id,
      project_id: course_id,
    }
    sendHttpPostRequest(
      'report/api/before_export/',
      _params,
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          getReportExportStatus()
          setExportModalLoading(true)
        } else {
          // message.error(res.m)
        }
      }
    )
  }

  // 导出报告
  const onExportReportClick = (action: any) => {
    let _params = {
      sessionid: Cookies.get('sessionid'),
      classroom_id: classroom_id,
      user_id_list: JSON.stringify(selectedRowKeys),
      project_id: course_id,
    }
    if (action) {
      if (action != 'by_id') {
        //     _params["user_id_list"] = JSON.stringify([currentStudentId.current]);
        // } else {
        _params['action'] = action
      }
    }
    _params['user_id_list'] =
      selectedRowKeys.length > 0
        ? JSON.stringify(selectedRowKeys)
        : currentStudentId.current != 0
        ? JSON.stringify([currentStudentId.current])
        : '[]'
    sendHttpPostRequest(
      'report/api/before_export/',
      _params,
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
        } else if (response.code >= 5000) {
          setReportExportModalVisible(true)
          setReportExportInfo(response.query_info)
          // setReportExportMessage(response.message);
          response.query_info.url ? setDownloadUrl(response.query_info.url) : ''
          action == 'join_queue' ? queryClassRoom() : ''
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 取消 报告 生成
  const onCancelExportReportTask = () => {
    let _params = {
      sessionid: Cookies.get('sessionid'),
      classroom_id: classroom_id,
      // user_id_list: JSON.stringify(selectedRowKeys),
      project_id: course_id,
    }
    _params['user_id_list'] =
      selectedRowKeys.length > 0
        ? JSON.stringify(selectedRowKeys)
        : currentStudentId.current != 0
        ? JSON.stringify([currentStudentId.current])
        : '[]'
    sendHttpPostRequest(
      'report/api/cancel_export_task/',
      _params,
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          message.success('任务取消成功')
          setTimeout(function () {
            queryClassRoom()
          }, 2000)
        } else if (response.code > 5000) {
          setReportExportModalVisible(true)
          setReportExportInfo(response.query_info)
          // setReportExportMessage(response.message);
          response.query_info.url ? setDownloadUrl(response.query_info.url) : ''
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 下载报告
  const downloadReport = () => {
    window.open(BACKEND_URL + downloadUrl)
  }

  const setScore = (user_id, score) => {
    if (score == null) {
      setScoreAction(false)
      return false
    }
    setStudentLoaded(false)
    sendHttpPostRequest(
      'classroom/api/user_score_classroom_report/',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        user_id_list: JSON.stringify([user_id]),
        score: score,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          message.success('设置成功')
          setScoreAction(false)

          {
            classStudentList?.map((record: any, index: number) => {
              user_id == record?.user_id
                ? (classStudentList[index].score = score)
                : ''
            })
          }
          setStudentLoaded(true)
          setClassStudentList(classStudentList)
          setReportScore(null as any)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const setListScore = (score) => {
    setStudentLoaded(false)
    sendHttpPostRequest(
      'classroom/api/user_score_classroom_report/',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        user_id_list: JSON.stringify(selectedRowKeys),
        score: score,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          message.success('设置成功')
          setScoreAction(false)
          // setTimeout(function () {
          //     queryClassRoom();
          // }, 1000);

          {
            classStudentList?.map((record: any, index: number) => {
              selectedRowKeys.includes(record?.user_id)
                ? (classStudentList[index].score = score)
                : ''
            })
          }
          setStudentLoaded(true)
          setClassStudentList(classStudentList)
          setReportScore(null as any)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  //渲染成绩
  const renderReportScore = (text: any, record: any) => {
    if (record.user_id == selectedStudentId) {
      return (
        <div>
          {scoreAction == false ? (
            <span>{reportScore ? reportScore : record.score}</span>
          ) : (
            [
              <InputNumber
                key="1"
                max={100}
                controls={false}
                min={0}
                bordered={false}
                defaultValue={record.score}
                style={{
                  width: 60,
                  background: '#fff',
                  color: '#333',
                  textAlign: 'center',
                }}
                onChange={(value) => {
                  setReportScore(value)
                }}
              />,
              <Button
                key="2"
                size="small"
                type="primary"
                style={{
                  width: 50,
                  height: 30,
                  boxShadow: 'none',
                  background: '#4f46e5',
                  color: '#F2F2F2',
                  textAlign: 'center',
                  marginLeft: 10,
                }}
                onClick={() => {
                  setScore(record.user_id, reportScore)
                }}
              >
                确定
              </Button>,
            ]
          )}
        </div>
      )
    } else {
      return <div>{record.score}</div>
    }
  }

  // 渲染操作
  const renderClassRoomActions = (text: any, record: any) => {
    return (
      <div>
        <Button
          style={{ color: '#f2f2f2', borderRadius: 20, fontSize: 14 }}
          size="small"
          type="link"
          onClick={() => {
            setSelectedStudentId(record.user_id)
            setScoreAction(true)
          }}
        >
          {' '}
          评分{' '}
        </Button>
        <Popconfirm
          placement="top"
          title={'您确定将该学员移出本班级吗？'}
          onCancel={(e: any) => {}}
          onConfirm={(e: any) => {
            deleteClassRoomStudent(record.user_id)
          }}
          okText="确认"
          cancelText="取消"
        >
          <Button
            style={{ color: '#f2f2f2', borderRadius: 20, fontSize: 14 }}
            size="small"
            type="link"
          >
            {' '}
            移出{' '}
          </Button>
        </Popconfirm>
      </div>
    )
  }

  // 重置密码确认

  const handleResetPassOk = () => {
    let data = {
      user_id_list: JSON.stringify(selectedRowKeys),
    }
    sendHttpPostRequest(
      'classroom/api/batch_reset_user_password',
      data,
      (res) => {
        if (res.code == 0) {
          message.success(res.msg)
        } else {
          message.error(res.msg)
        }
        setResetPasswordModalVis(false)
      }
    )
  }

  const renderInfo = (text: any, record: any, index: any) => {
    let avatar = defaultUserAvatar
    if (record.avatar && record.avatar !== '') {
      avatar = record.avatar
    }

    return (
      <div>
        <img
          src={avatar?.startsWith('http') ? avatar : BACKEND_API_URL + avatar}
          alt=""
          style={{ width: 48, height: 48, borderRadius: '50%', marginBottom: 6 }}
        />
        <div style={{fontSize:16, fontWeight:600}}>{record.real_name ? record.real_name : record.user_name}</div>
      </div>
    )
  }

  const renderTask = (menu: any, record: any, index: any) => {
    return (
      <div style={{ padding: 10,  }}>
        <Row
          justify="end"
          align="middle"
          gutter={[8, 8]}
          style={{ marginBottom: 10 }}
        >
          <Col>
            <div
              style={{
                fontSize: 12,
                height: 12,
                width: 12,
                backgroundColor: '#4f46e5',
              }}
            ></div>
          </Col>
          <Col style={{ fontSize: 12 }}>通过 {record.pass_count} </Col>
          <Col>
            <div style={{ height: 12, width: 12, background: '#9a3232' }}></div>
          </Col>

          <Col style={{ fontSize: 12 }}>未通过 {record.fail_count} </Col>
          <Col>
            <div style={{ height: 12, width: 12, background: '#f2f2f2' }}></div>
          </Col>

          <Col style={{ fontSize: 12 }}>未提交 {record.not_count} </Col>
        </Row>
        <div style={{ marginTop: -30 }}>
          {menu?.map((chapter: any, index: number) => (
            <>
              <Row
                align="middle"
                justify={'start'}
                gutter={[2, 2]}
                style={{ textAlign: 'left', width: '100%' }}
              >
                <Col>
                  <div
                    style={{
                      textAlign: 'center',
                      borderRadius: 12,
                      height: 24,
                      width: 24,
                      backgroundColor: 'rgb(59, 109, 116,0.1)',
                      fontSize: 12,
                      lineHeight: 2,
                    }}
                  >
                    {' '}
                    {chapter.is_pass == 0 ? <LockOutlined /> : index + 1}{' '}
                  </div>
                </Col>
                {chapter?.tasks?.map((task: any, taskInd: number) => (
                  <Col key={index}>
                    <div
                      onClick={() => {
                        setCurrentTask(task)
                        setStudentAvatar(
                          record.avatar !== ''
                            ? record.avatar
                            : defaultUserAvatar
                        )
                        setStudentName(
                          record.real_name == ''
                            ? record.user_name
                            : record.real_name
                        )
                        queryClassRoomStudentSubmission(record.user_id, task.id)
                      }}
                      style={{
                        backgroundColor: getColorByStatus(task.status),
                        color: getFontColorByStatus(task.status),
                        margin: 5,
                        padding: 'auto',
                        textAlign: 'center',
                        height: 24,
                        lineHeight: '24px',
                        width: 24,
                        fontSize: 12,
                        borderRadius: 2,
                        cursor: 'pointer',
                      }}
                    >
                      {taskInd + 1}
                    </div>
                  </Col>
                ))}
              </Row>
            </>
          ))}
        </div>
      </div>
    )
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => {
      setSelectedRowKeys(keys)
    },
  }
  // 表格列
  const student_cols: any = [
    {
      title: '序号',
      dataIndex: 'user_id',
      key: 'user_id',
      width: '50px',
      align: 'left',
      fixed: 'left',
      render: (text, record) =>
        (page.current - 1) * pageSize.current +
        classStudentList.indexOf(record) +
        1,
    },
    {
      title: '姓名',
      dataIndex: 'real_name',
      key: 'real_name',
      width: '150px',
      align: 'left',
      //render: (text, record) => record.real_name ? record.real_name : record.user_name,
      render: (t, r, i) => {
        return (
        <Row align="middle" justify="start" style={{ gap: '5px' }}>
            <Col>
            <img  src={ r.avatar?.startsWith("http") ? r.avatar : BACKEND_API_URL + r.avatar} alt="" style={{width:24,height:24,borderRadius:12,marginRight:6}}/>
            </Col>
            <Col>{r.real_name == "" ? r.user_name : r.real_name}</Col>
        </Row>
        )
    },
    },
    {
      title: '学号',
      dataIndex: 'number',
      key: 'number',
      width: '120px',
      align: 'left',
      ellipsis: true,
    },
    {
      title: '加入日期',
      dataIndex: 'join_time',
      key: 'join_time',
      width: '120px',
      align: 'left',
      render: (text) => text?.slice(0, 10),
    },
    {
      title: '实训进度',
      dataIndex: 'task_complete_percent',
      key: 'task_complete_percent',
      width: '80px',
      align: 'center',
      render: (text) => <div><div>{text + '%'}</div><div><Progress showInfo={false} strokeColor='#4f46e5' trailColor={'#4f46e533'} percent={text} /></div></div>,
    },
    {
      title: '在线时长',
      dataIndex: 'online_hours',
      key: 'online_hours',
      width: '80px',
      align: 'center',
      render: (text) => text + 'h',
    },
    {
      title: '报告进度',
      dataIndex: 'report_complete_percent',
      key: 'report_complete_percent',
      width: '80px',
      align: 'center',
      render: (text) => <div><div>{text + '%'}</div><div><Progress showInfo={false} strokeColor='#10b981' trailColor={'#10b98133'} percent={text} /></div></div>,
    },
    {
      title: '成绩',
      dataIndex: 'score',
      key: 'score',
      width: '140px',
      align: 'center',
      render: renderReportScore,
    },
    {
      title: '报告',
      dataIndex: 'report',
      key: 'report',
      width: '130px',
      align: 'center',
      render: (text, record) => {
        return (
          <Row align={'middle'} justify={'center'} wrap={false}>
            <Col span={12}>
              <Button
                onClick={() => {
                  window.open(
                    `/user_report_preview?project_id=${course_id}&user_id=${record.user_id}&classroom_id=${classroom_id}`
                  )
                }}
                type="link"
              >
                查看
              </Button>
            </Col>
            <Col span={12}>
            {record.download_status != 0 && <img height={16} width={16} src={lodingGif}></img>}
                  <Button
                    style={{ padding: '0px' }}
                    onClick={() => {
                      if (record.download_status == 1) {
                        return
                      }
                      record.download_status = 1
                      setClassStudentList([...classStudentList])
                      let data = {
                        user_id_list: JSON.stringify([record.user_id]),
                        classroom_id: classroom_id,
                        project_id: course_id,
                      }
                      sendHttpPostRequest(
                        'report/api/create_export_report',
                        data,
                        (res) => {
                          if (res.code == 0) {
                            record.download_status = 0
                            setClassStudentList([...classStudentList])
                            window.location.href =
                              BACKEND_API_URL +
                              'report/api/download_export_report?project_id=' +
                              course_id +
                              '&classroom_id=' +
                              classroom_id +
                              '&user_id=' +
                              record.user_id +
                              '&sessionid=' +
                              Cookies.get('sessionid')
                          }else if (res.code == -1) {
                            record.download_status = 0
                            setClassStudentList([...classStudentList])
                            message.error(res.message)
                          } else {
                            message.error(res.message)
                          }
                        }
                      )
                    }}
                    type="link"
                    disabled={exportModalLoading}
                  >
                    {record.download_status == 0 ? '下载' : '下载中'}
                  </Button>
                </Col>
 
          </Row>
        )
      },
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: '120px',
      ellipsis: false,
      align: 'center',
      fixed: 'right',
      render: renderClassRoomActions,
    },
  ]

  const task_cols: any = [
    {
      title: '序号',
      dataIndex: 'user_id',
      key: 'user_id',
      width: '60px',
      align: 'center',
      render: (text, record) =>
        (page.current - 1) * pageSize.current +
        studentTaskStatusList.indexOf(record) +
        1,
    },
    {
      title: '姓名',
      dataIndex: 'real_name',
      key: 'real_name',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: renderInfo,
    },
    {
      title: '实训任务',
      dataIndex: 'menu',
      key: 'menu',
      width: '400px',
      ellipsis: true,
      align: 'center',
      render: renderTask,
    },
  ]


  return (
    <div 
    >
      <div className={projectStyles.teacherClassroomHeader}>
        {/* 顶部：教师头像 + 班级名称 + 班号 + 操作按钮 */}
        <div style={{display:'flex', alignItems:'center', gap:20, marginBottom:20}}>
          <img
            src={classRoomInfo?.teacher_avatar?.startsWith("http") ? classRoomInfo?.teacher_avatar : BACKEND_API_URL + 'static/' + classRoomInfo?.teacher_avatar}
            style={{height:52, width:52, borderRadius:'50%', border:'2px solid #e0e7ff', flexShrink:0}}
          />
          <div style={{flex:1, minWidth:0}}>
            <div style={{display:'flex', alignItems:'center', gap:12, flexWrap:'wrap'}}>
              <div className={projectStyles.teacherClassroomName}>{classRoomInfo?.name}</div>
              <div className={projectStyles.teacherClassroomNumber}><ProfileOutlined style={{marginRight:3}}/> 班号: {classRoomInfo?.number}</div>
            </div>
            <div style={{fontSize:14, color:'#6b7280', marginTop:4}}>
              教师: {classRoomInfo?.teacher_real_name ? classRoomInfo?.teacher_real_name : classRoomInfo?.user_name}
            </div>
          </div>
          <div style={{display:'flex', alignItems:'center', gap:10, flexShrink:0}}>
            <Tooltip title={'若要下载班级最新报告，请先点击生成报告'} placement="bottom">
              <ExclamationCircleOutlined style={{color:'#9ca3af', fontSize:16}}/>
            </Tooltip>
            <Button
              type="primary"
              style={{borderRadius:8, height:36, fontSize:14, display:'flex', alignItems:'center', gap:4}}
              loading={exportModalLoading}
              onClick={() => { setExportBeforeModalVis(true) }}
            >
              <FileTextOutlined />
              生成报告
            </Button>
            <Button
              style={
                exportModalLoading
                  ? { borderRadius:8, height:36, fontSize:14, color:'rgba(0,0,0,0.25)', backgroundColor:'#f5f5f5', border:'1px solid #e5e7eb', display:'flex', alignItems:'center', gap:4 }
                  : { borderRadius:8, height:36, fontSize:14, color:'#4f46e5', backgroundColor:'#eef2ff', border:'1px solid #c7d2fe', display:'flex', alignItems:'center', gap:4 }
              }
              disabled={exportModalLoading}
              onClick={() => { beforeDownloadReport() }}
            >
              <DownloadOutlined />
              下载报告
            </Button>
            <Button
              style={{borderRadius:8, height:36, fontSize:14, color:'#4f46e5', backgroundColor:'#fff', border:'1px solid #c7d2fe', display:'flex', alignItems:'center', gap:4}}
              onClick={() => { exportScore() }}
            >
              <TableOutlined />
              导出成绩
            </Button>
            <Button
              style={{borderRadius:8, height:36, fontSize:14, color:'#6b7280', backgroundColor:'#fff', border:'1px solid #d1d5db', display:'flex', alignItems:'center', gap:4}}
              onClick={editClass}
            >
              <EditOutlined />
              编辑班级
            </Button>
          </div>
        </div>

        {/* 底部：信息卡片 */}
        <Row wrap={false} align={'top'} gutter={[16,16]}>
          <Col span={8}>
            <div className={projectStyles.teacherClassroomItem}>
              <div className={projectStyles.teacherClassroomItemTitle}>
                <KeyOutlined style={{marginRight:3}} /> 班级密码
              </div>
              <div className={projectStyles.teacherClassroomItemContent}>
                {classRoomInfo?.password}
              </div>
            </div>
          </Col>
          <Col span={8}>
            <div className={projectStyles.teacherClassroomItem}>
              <div className={projectStyles.teacherClassroomItemTitle}>
                <CalendarOutlined style={{marginRight:3}} /> 创建日期
              </div>
              <div className={projectStyles.teacherClassroomItemContent}>
                {classRoomInfo?.create_time?.slice(0,10)}
              </div>
            </div>
          </Col>
          <Col span={8}>
            <div className={projectStyles.teacherClassroomItem}>
              <div className={projectStyles.teacherClassroomItemTitle}>
                <TeamOutlined style={{marginRight:3}} /> 班级人数
              </div>
              <div className={projectStyles.teacherClassroomItemContent}>
                {classStudentTotalCount}
              </div>
            </div>
          </Col>
        </Row>
      </div>


      <Tabs
        activeKey={activeTabkKey}
        onTabClick={(key, event) => {
          setActiveTabkKey(key)
          page.current = 1
          if(key == '1'){
              queryClassRoom()
          }else{
            queryStudentTaskStatus()
          }
        }}
        type="line"
        size="middle"
        tabPosition="top"
        style={{ position: 'relative' }}
      >
        <TabPane tab={<div style={{fontSize:16, fontWeight:500}}> <TeamOutlined style={{marginRight:3}}/> 学生信息</div>} key="1">
          <div
            className={projectStyles.teacherClassroomTabContent}
          >
            <div className={idataCodingStyles.tableWrapper}>
              <Row align={'middle'} gutter={12} >
                <Col flex={'auto'}>
                </Col>
                <Col flex={'300px'}>

                      <div >                         
                        <Input                   
                        onPressEnter={()=>{page.current = 1; queryClassRoom()}}
                        onChange={(e) => {
                      queryStudentContent.current = e.target.value
                    }} 
                        size="large" 
                        placeholder="请输入学生姓名..." 
                        prefix={<SearchOutlined />} 
                        style={{borderRadius:8,width:300}}
                        //className={projectStyles.studentSearchInput}
                    /></div>

                </Col>
                <Col flex={'320px'}>
                  <div
                    style={{
                      textAlign: 'right',
                    }}

                  >
                    {/* 搜索框 */}

                    {/** 本地部署版本功能 */}
                    <Button
                      style={{
                        width: 90,
                        borderRadius: 27,
                        border: 0,
                        marginRight: 10,
                      }}
                      type="primary"
                      disabled={!selectedRowKeys.length}
                      onClick={() => {
                        setResetPasswordModalVis(true)
                      }}
                    >
                      重置密码
                    </Button>
                    <Button
                      style={{
                        width: 90,
                        borderRadius: 27,
                        marginRight: 10,
                      }}
                      type="primary"
                      disabled={selectedRowKeys.length == 0}
                      onClick={() => {
                        setScoreActionVisible(true)
                      }}
                    >
                      批量评分
                    </Button>
                    <Button
                      style={{
                        width: 90,
                        borderRadius: 27,
                        color: '#f2f2f2',
                        backgroundColor: '#4f46e5',
                        border: 0,
                      }}
                      onClick={() => {
                        setAddStudentModalVis(true)
                      }}
                    >
                      添加学生
                    </Button>

                  </div>
                </Col>
              </Row>

              <div
                hidden={studentLoaded}
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%,-50%)',
                  textAlign: 'center',
                  marginTop: '40px',
                }}
              >
                <img height={100} width={100} src={lodingGif}></img>
              </div>
              {classStudentList?.length != 0 ? (
                <div hidden={!studentLoaded} style={{ marginTop: '20px' }}>
                  <Table
                    className={projectStyles.studentTable}
                    dataSource={classStudentList}
                    columns={student_cols}
                    rowKey={(record) => record.user_id}
                    scroll={{ x: 1000 }}
                    pagination={false}
                    size="small"
                    rowSelection={rowSelection}
                  />
                </div>
              ) : (
                <div
                  hidden={!studentLoaded}
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    color: '#9ca3af',
                    marginTop: '20px',
                    padding: '40px 0',
                  }}
                >
                  <img
                    src={studentempty}
                    alt=""
                    width={160}
                    height={160}
                    style={{ margin: '0 auto 16px', display: 'block', opacity: 0.35, filter: 'grayscale(60%)' }}
                  />
                  <p style={{ fontSize: 15, color: '#6b7280', marginBottom: 4 }}>该班级还没有学生</p>
                  <p style={{ fontSize: 13, color: '#9ca3af' }}>快去邀请学生加入班级吧！</p>
                </div>
              )}
            </div>
            <div className={idataCodingStyles.paginationWrapper}>
              <ConfigProvider locale={zhCN}>
                <div
                  style={{
                    marginBottom: 20,
                    paddingTop: 20,
                    textAlign: 'center',
                  }}
                >
                  <Pagination
                    defaultCurrent={1}
                    total={classStudentResultSum}
                    defaultPageSize={pageSize.current}
                    current={page.current}
                    hideOnSinglePage={true}
                    onChange={onPageChange}
                    pageSizeOptions={['15', '30', '45', '60', '75', '90']}
                  />
                </div>
              </ConfigProvider>
            </div>
          </div>
        </TabPane>

        <TabPane tab={<div style={{fontSize:16, fontWeight:500}}> <BarsOutlined style={{marginRight:3}} /> 任务进度</div>} key="2">
          <div
            className={projectStyles.teacherClassroomTabContent}
          >
            <div className={idataCodingStyles.tableWrapper}>
              <div
                hidden={studentLoaded}
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%,-50%)',
                  textAlign: 'center',
                }}
              >
                <img height={100} width={100} src={lodingGif}></img>
              </div>
              {studentTaskStatusList?.length != 0 ? (
                <div hidden={!studentLoaded}>
                  <Table
                    dataSource={studentTaskStatusList}
                    columns={task_cols}
                    rowKey={(record) => record.user_id}
                    pagination={false}
                    scroll={{ x: 800 }}
                    size="small"
                    className={projectStyles.studentTable}
                  />
                </div>
              ) : (
                <div
                  hidden={!studentLoaded}
                  style={{ width: '100%', textAlign: 'center', color: '#9ca3af', padding: '40px 0' }}
                >
                  <img
                    src={studentempty}
                    alt=""
                    width={160}
                    height={160}
                    style={{ margin: '0 auto 16px', display: 'block', opacity: 0.35, filter: 'grayscale(60%)' }}
                  />
                  <p style={{ fontSize: 15, color: '#6b7280', marginBottom: 4 }}>该班级还没有学生</p>
                  <p style={{ fontSize: 13, color: '#9ca3af' }}>快去邀请学生加入班级吧！</p>
                </div>
              )}
            </div>
            <div className={idataCodingStyles.paginationWrapper}>
              <ConfigProvider locale={zhCN}>
                <div
                  style={{
                    marginBottom: 20,
                    paddingTop: 20,
                    textAlign: 'center',
                  }}
                >
                  <Pagination
                    defaultCurrent={1}
                    total={classStatusStudentResultSum}
                    defaultPageSize={pageSize.current}
                    current={page.current}
                    hideOnSinglePage={true}
                    onChange={onStatusPageChange}
                    pageSizeOptions={['15', '30', '45', '60', '75', '90']}
                  />
                </div>
              </ConfigProvider>
            </div>
          </div>

          <Modal
            title={
              <div
                style={{ cursor: 'move', display: 'flex', alignItems: 'center', gap: 10 }}
                onMouseOver={() => { if (disabled) setDisabled(false) }}
                onMouseOut={() => { setDisabled(true) }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                <img
                  src={studentAvatar?.startsWith('http') ? studentAvatar : BACKEND_API_URL + studentAvatar}
                  alt=""
                  style={{ width: 28, height: 28, borderRadius: 14 }}
                />
                <span style={{ fontWeight: 600, color: '#1f2937' }}>{studentName}</span>
                <span style={{ color: '#6b7280', fontWeight: 400, fontSize: 14 }}>—</span>
                <span style={{ color: '#4f46e5', fontWeight: 500, fontSize: 14 }}>{currentTask?.name}</span>
              </div>
            }
            width={1000}
            bodyStyle={{ maxHeight: 560, overflowY: 'auto' }}
            closable={true}
            centered={true}
            open={isDetailModalVisible}
            onCancel={() => { setIsDetailModalVisible(false) }}
            className={projectStyles.detailModal}
            footer={null}
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ display: 'flex', gap: 16, padding: '8px 0' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className={projectStyles.codePreviewCard}>
                  <div className={projectStyles.codePreviewHeader}>学生代码</div>
                  <div className={projectStyles.codePreviewBlock}>
                    <SyntaxHighlighter
                      language="python"
                      style={oneLight}
                      showLineNumbers
                      wrapLongLines
                      customStyle={{ margin: 0, borderRadius: '0 0 10px 10px', fontSize: 14 }}
                    >
                      {sudentCode || ''}
                    </SyntaxHighlighter>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className={projectStyles.codePreviewCard}>
                  <div className={projectStyles.codePreviewHeader}>参考代码</div>
                  <div className={projectStyles.codePreviewBlock}>
                    <SyntaxHighlighter
                      language="python"
                      style={oneLight}
                      showLineNumbers
                      wrapLongLines
                      customStyle={{ margin: 0, borderRadius: '0 0 10px 10px', fontSize: 14 }}
                    >
                      {studentAnswer || ''}
                    </SyntaxHighlighter>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </TabPane>
      </Tabs>
      <Modal
        title={null}
        width={480}
        closable={true}
        centered={true}
        open={isEditModalVisible}
        onCancel={handleEditCancel}
        className={projectStyles.modalCreateClass}
        destroyOnClose={true}
        footer={null}
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        {/* 弹窗头部 */}
        <div
          style={{ cursor: 'move', padding: '28px 28px 20px' }}
          onMouseOver={() => { if (disabled) setDisabled(false) }}
          onMouseOut={() => setDisabled(true)}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{
              width: 44, height: 44, borderRadius: 12, flexShrink: 0,
              background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(79,70,229,0.25)',
            }}>
              <EditOutlined style={{ color: '#fff', fontSize: 20 }} />
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#1f2937', lineHeight: 1.3 }}>编辑班级</div>
              <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 2 }}>修改班级信息，变更立即生效</div>
            </div>
          </div>
        </div>

        {/* 表单区域 */}
        <div style={{ padding: '0 28px 8px' }} className={projectStyles.modalFormContent}>
          <div className={projectStyles.formFieldGroup}>
            <div className={projectStyles.formFieldLabel}>
              <ProfileOutlined style={{ marginRight: 6, color: '#4f46e5' }} />
              班级名称
              <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>
            </div>
            <Input
              value={editClassRoomName}
              onChange={(e) => setEditClassRoomName(e.target.value)}
              placeholder="请输入班级名称"
              maxLength={30}
              showCount
            />
          </div>
          <div className={projectStyles.formFieldGroup}>
            <div className={projectStyles.formFieldLabel}>
              <FieldNumberOutlined style={{ marginRight: 6, color: '#4f46e5' }} />
              班级编号
              <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>
            </div>
            <Input
              value={editClassRoomNumber}
              onChange={(e) => setEditClassRoomNumber(e.target.value)}
              placeholder="请输入班级编号"
            />
          </div>
          <div className={projectStyles.formFieldGroup}>
            <div className={projectStyles.formFieldLabel}>
              <LockOutlined style={{ marginRight: 6, color: '#4f46e5' }} />
              加入密码
              <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>
            </div>
            <Input.Password
              value={editClassRoomPasswd}
              onChange={(e) => setEditClassRoomPasswd(e.target.value)}
              placeholder="学生加入班级时需输入此密码"
              visibilityToggle={true}
            />
          </div>
        </div>

        {/* 底部按钮 */}
        <div style={{
          display: 'flex', gap: 10, padding: '16px 28px 28px', justifyContent: 'flex-end',
          borderTop: '1px solid #f3f4f6', marginTop: 8,
        }}>
          <Button
            style={{ height: 40, borderRadius: 8, padding: '0 20px', fontSize: 14, color: '#6b7280', borderColor: '#e5e7eb' }}
            onClick={handleEditCancel}
          >
            取消
          </Button>
          <Button
            type="primary"
            style={{
              height: 40, borderRadius: 8, padding: '0 24px', fontSize: 14, fontWeight: 600,
              background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
              border: 'none',
              boxShadow: '0 4px 12px rgba(79,70,229,0.3)',
            }}
            onClick={() => {
              if (!editClassRoomNumber) {
                message.error('班号不能为空！')
                return
              } else if (!editClassRoomName) {
                message.error('班级名称不能为空！')
                return
              }
              updateClassRoom(classroom_id, editClassRoomPasswd, editClassRoomName, editClassRoomNumber)
            }}
          >
            确认保存
          </Button>
        </div>
      </Modal>

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move'}}
            onMouseOver={() => { if (disabled) setDisabled(false) }}
            onMouseOut={() => { setDisabled(true) }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            批量评分
          </div>
        }
        width={400}
        closable={true}
        onCancel={() => { setScoreActionVisible(false) }}
        centered={true}
        open={scoreActionVisible}
        className={projectStyles.modalCreateClass}
        footer={
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
            <Button
              className={projectStyles.stepsBtn}
              onClick={() => {
                setScoreActionVisible(false)
              }}
            >
              取消
            </Button>
            <Button
              className={projectStyles.stepsBtn}
              type="primary"
              style={{ color: '#fff' }}
              onClick={() => {
                setListScore(batchScore)
                setReportScore(batchScore)
                setScoreActionVisible(false)
              }}
            >
              确认
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        <div
          style={{
            margin: '0 auto',
            textAlign: 'center',
            padding: '8px 0',
            color: '#374151',
            fontSize: 15,
          }}
        >
          请输入您的评分
          <InputNumber
            controls={false}
            max={100}
            min={0}
            style={{ width: 70, borderRadius: 8, marginLeft: 10, borderColor: '#d1d5db' }}
            onChange={(value) => {
              setBatchScore(value)
            }}
          />
        </div>
      </Modal>

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move' }}
            onMouseOver={() => { if (disabled) setDisabled(false) }}
            onMouseOut={() => { setDisabled(true) }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            {reportExportInfo?.type == 'tips'
              ? '提示'
              : reportExportInfo?.type == 'warning'
              ? '警告'
              : reportExportInfo?.type == 'error'
              ? '错误'
              : '提示'}
          </div>
        }
        width={450}
        closable={true}
        onCancel={() => { setReportExportModalVisible(false); queryClassRoom(); }}
        centered={true}
        open={reportExportModalVisible}
        className={projectStyles.modalCreateClass}
        footer={
          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, flexWrap: 'wrap' }}>
            <Button
              hidden={!reportExportInfo?.buttons.includes(0)}
              className={projectStyles.stepsBtn}
              onClick={() => {
                setReportExportModalVisible(false)
                queryClassRoom()
              }}
            >
              关闭
            </Button>
            <Button
              hidden={!reportExportInfo?.buttons.includes(1)}
              className={projectStyles.stepsBtn}
              type="primary"
              style={{ color: '#fff' }}
              onClick={() => {
                setReportExportModalVisible(false)
              }}
            >
              确认
            </Button>
            <Button
              hidden={!reportExportInfo?.buttons.includes(3)}
              className={projectStyles.stepsBtnLg}
              type="primary"
              style={{ color: '#fff' }}
              onClick={() => {
                setReportExportModalVisible(false)
                onExportReportClick('rebuild')
              }}
            >
              重新生成
            </Button>
            <Button
              hidden={!reportExportInfo?.buttons.includes(5)}
              className={projectStyles.stepsBtnLg}
              type="primary"
              style={{ color: '#fff' }}
              onClick={() => {
                setReportExportModalVisible(false)
                onExportReportClick('join_queue')
              }}
            >
              加入队列
            </Button>
            <Button
              hidden={!reportExportInfo?.buttons.includes(4)}
              className={projectStyles.stepsBtnLg}
              type="primary"
              style={{ color: '#fff' }}
              onClick={() => {
                setReportExportModalVisible(false)
                onCancelExportReportTask()
              }}
            >
              取消生成
            </Button>
            <Button
              hidden={!reportExportInfo?.buttons.includes(2)}
              className={projectStyles.stepsBtn}
              onClick={() => {
                setReportExportModalVisible(false)
                downloadReport()
              }}
            >
              下载
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        <div
          style={{ margin: '0 auto', textAlign: 'center', padding: '8px 0', color: '#374151', fontSize: 15 }}
        >
          <div>{reportExportInfo?.message}</div>
        </div>
      </Modal>
      <PublicTipModal
        theme={'white'}
        open={resetPasswordModalVis}
        setOpen={setResetPasswordModalVis}
        modalTitle={'提示'}
        handleOk={handleResetPassOk}
        handleCancel={() => {
          setResetPasswordModalVis(false)
        }}
        modalContent={
          <Row align="middle" justify="center">
            <Col>
              确定要重置选中的{' '}
              <span className={projectStyles.hltext}>
                {selectedRowKeys.length}{' '}
              </span>{' '}
              个学生的密码
            </Col>
            <Col>
              为默认密码<span className={projectStyles.hltext}>123456</span>
            </Col>
          </Row>
        }
      />
      <PublicTipModal
        theme={'white'}
        open={exportBeforeModalVis}
        setOpen={setExportBeforeModalVis}
        modalTitle={'提示'}
        handleOk={() => {
          currentStudentId.current = 0
          exportAllClassroomReports()
          setExportBeforeModalVis(false)
        }}
        handleCancel={() => {
          setExportBeforeModalVis(false)
        }}
        modalContent={'确定要生成整个班级的PDF报告？'}
      />
      <PublicTipModal
        theme={'white'}
        open={downloadBeforeModalVis}
        setOpen={setDownloadBeforeModalVis}
        modalTitle={'提示'}
        handleOk={() => {
          setDownloadBeforeModalVis(false)
          downloadClassroomReport()
        }}
        handleCancel={() => {
          setDownloadBeforeModalVis(false)
        }}
        modalContent={
          <Row align={'middle'} justify={'center'}>
            <Col>
              确定要下载{' '}
              <span style={{ color: '#4f46e5', fontWeight: 600 }}>
                {downloadBeforeInfo?.last_time}
              </span>{' '}
              生成的共{' '}
              <span style={{ color: '#4f46e5', fontWeight: 600 }}>
                {downloadBeforeInfo?.report_count}
              </span>{' '}
              位学生的报告吗？
            </Col>
          </Row>
        }
      />

      {addStudentModalVis && (
        <AddStudentModal
          project_id={course_id}
          theme={'white'}
          open={addStudentModalVis}
          setOpen={setAddStudentModalVis}
          onCancel={() => {
            setAddStudentModalVis(false)
          }}
          college_id={college_id}
          classroom_id={classroom_id}
          actionCallback={queryClassRoom}
        />
      )}
    </div>
  )
}

export default ProjectClassroomManager
